/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Auth } from 'app/scripts/db/Auth';
import { isOverLimit } from 'app/scripts/lib/limits';
import { limitErrorPopover } from 'app/scripts/views/lib/limitErrorPopover';

const trackingArea = 'boardMemberLimit';
const maybeDisplayMemberLimitsError = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elem: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  board: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  member?: any,
) {
  const m = (() => {
    if (
      board != null
        ? isOverLimit('boards', 'totalMembersPerBoard', board.get('limits'))
        : undefined
    ) {
      return {
        message: 'members exceeds total per board limit',
        params: { boardName: board.get('name'), boardId: board.get('id') },
      };
    } else if (
      member != null
        ? isOverLimit('boards', 'totalPerMember', member.get('limits'))
        : undefined
    ) {
      if (Auth.isMe(member)) {
        return { message: 'your boards exceed total per member limit' };
      } else {
        return {
          message: 'boards exceeds total per member limit',
          params: { memberName: member.get('name') },
        };
      }
    }
  })();

  if (m != null) {
    limitErrorPopover({
      trackingArea,
      elem,
      ...m,
    });
    return true;
  }
  return false;
};

export { maybeDisplayMemberLimitsError };
